(window.OEResourcePostContent = function ($, Behaviors) {
    "use strict";

    const module = {};

    function OEResourcePostContent() {
        const lis = document.querySelectorAll('[data-target]');

        if(!lis.length) return;

        const scrollTo = () => {
            lis.forEach(item => {
                item.addEventListener('click', event => {
                    const target = event.target.getAttribute('data-target');
                    const heading = document.querySelector(`[data-heading="${target}"]`);
                    if (heading) {
                        window.scroll({
                            top: heading.getBoundingClientRect().top + window.scrollY - 130, // Add the offset here.
                            behavior: 'smooth'
                        });
                    }
                });
            });
        }

        scrollTo();

        let headings = document.querySelectorAll('[data-heading]'); // Replace '.anchor' with your own selector

        window.addEventListener('scroll', function () {
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

            // Remove 'active' class from all ToC links
            headings.forEach((heading) => {
                let headingAttribute = heading.dataset.heading;
                let link = document.querySelector(`[data-target="${headingAttribute}"]`);
                if (link) {
                    link.classList.remove('active');
                    link.classList.remove('parent-active');
                }
            });

            // Iterate backwards through headings, add 'active' class to first heading that's 75px above scrollTop
            for (let i = headings.length - 1; i >= 0; i--) {
                let heading = headings[i];
                let headingTop = heading.getBoundingClientRect().top + window.scrollY;

                if (scrollTop > headingTop - 200) {
                    let headingAttribute = heading.dataset.heading;
                    let link = document.querySelector(`[data-target="${headingAttribute}"]`);

                    if (link) {
                        link.classList.add('active');
                        const parent = link.parentElement.parentElement;
                        if (parent.matches('li')) {
                            parent.classList.add('parent-active');
                        }
                    }
                    break;
                }
            }
        });
    }

    module.OEResourcePostContent = OEResourcePostContent;

    document.addEventListener('DOMContentLoaded', OEResourcePostContent);

    return module;

}(window.jQuery, window.Behaviors));

